import { useEffect, useRef, useState } from 'react'
import { gsap } from 'gsap'
import Icons from './Icons'

const platforms = [
  {
    icon: Icons.Phone,
    title: '手机端',
    description: '随时随地交易',
    features: ['实时行情', '一键交易', '生物识别'],
  },
  {
    icon: Icons.Tablet,
    title: '平板端',
    description: '更大视野体验',
    features: ['专业图表', '深度分析', '多窗口操作'],
  },
  {
    icon: Icons.Desktop,
    title: '电脑端',
    description: '专业交易首选',
    features: ['API交易', '批量操作', '高级策略'],
  },
]

export function AppShowcase() {
  const showcaseRef = useRef<HTMLDivElement>(null)
  const [activePlatform, setActivePlatform] = useState(0)

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.platform-card',
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.15,
          scrollTrigger: {
            trigger: showcaseRef.current,
            start: 'top 80%',
          },
        }
      )
    }, showcaseRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      ref={showcaseRef}
      className="section-padding relative overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#13131a] to-[#0a0a0f]" />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="gradient-text">全平台覆盖</span>
          </h2>
          <p className="text-[#8080a0] text-lg max-w-2xl mx-auto">
            无论您使用什么设备，都能享受一致的优质交易体验
          </p>
        </div>

        {/* Platforms Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {platforms.map((platform, index) => (
            <div
              key={index}
              className={`platform-card cyber-card cursor-pointer transition-all ${
                activePlatform === index ? 'border-[#ff00ff]' : ''
              }`}
              onClick={() => setActivePlatform(index)}
            >
              <div className="text-center">
                <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 transition-colors ${
                  activePlatform === index
                    ? 'bg-[rgba(255,0,255,0.2)]'
                    : 'bg-[rgba(255,0,255,0.1)]'
                }`}>
                  <div className={activePlatform === index ? 'text-[#ff00ff]' : 'text-[#8080a0]'}>
                    <platform.icon />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-[#e0e0ff] mb-2">
                  {platform.title}
                </h3>
                <p className="text-[#8080a0] mb-4">{platform.description}</p>
                <ul className="space-y-2">
                  {platform.features.map((feature, i) => (
                    <li key={i} className="flex items-center justify-center gap-2 text-sm text-[#8080a0]">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#00ffff]" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Download Section */}
        <div className="cyber-card text-center max-w-2xl mx-auto">
          <h3 className="text-2xl font-semibold text-[#e0e0ff] mb-4">
            下载okb官方APP
          </h3>
          <p className="text-[#8080a0] mb-6">
            立即下载体验，开启您的数字资产之旅
          </p>
          <a
            href="https://download.prhci.com/upgradeapp/android_1P9999.apk"
            target="_blank"
            rel="noopener"
            className="btn-primary inline-flex items-center gap-2"
          >
            <Icons.Download />
            立即下载
          </a>
          <p className="text-sm text-[#8080a0] mt-4">
            支持 iOS、Android、Windows、macOS
          </p>
        </div>
      </div>
    </section>
  )
}
